export const privateAccessType = "t1HSKd";
export default {privateAccessType};